import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import client from '../../sanity/client';
import { useLanguage } from '../../components/LanguageContext';

import './SubPage.scss';
import { gsap } from 'gsap';

const SubPageChawans = () => {
  const [data, setData] = useState(null);
  const [chawans, setChawans] = useState([]);
  const [isAnimating, setIsAnimating] = useState(true);
  const { language } = useLanguage();
  const pageTitle = {
    fr: 'chawans',
    en: 'chawans'
  };
  useEffect(() => {
    const fetchData = async () => {
      const query = `*[_type == "subPageChawan"] | order(order asc) {
        title,
        "imageUrl": image.asset->url,
        slug,
        order
      }`;

      const result = await client.fetch(query);
      setChawans(result);
      setData(result);
      setIsAnimating(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!isAnimating && data) {
      gsap.fromTo(
        '.gallery',
        { opacity: 0.2 },
        { opacity: 1, duration: 1.2, ease: 'power1.out' }
      );
    }
  }, [isAnimating, data]);

  if (isAnimating) return <div style={{ opacity: 0 }}>Loading...</div>;

  return (
    <div className="sub-page">
      <h2>{pageTitle[language]}</h2>
      <div className="gallery">
        {chawans.map((chawan) => (
          chawan.slug?.current ? (
            <div key={chawan.slug.current} className="item">
              <Link to={`/ceramiste/chawans/${chawan.slug.current}`}>
                <img src={chawan.imageUrl} alt={chawan.title} />
              </Link>
            </div>
          ) : null
        ))}
      </div>
    </div>
  );
};

export default SubPageChawans;